import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import VideoPlayer from "../../../shared/video/video_room/player/video_player";
import classNames from "classnames";
import Select from "react-select";
import {Controller} from "react-hook-form";
import PhotoBooth from "../../../shared/photo_booth/photo_booth";

const RenderedPhotoBooth = (props) => {
  const tagOwner = useSelector(state => state.tagOwner)
  const photoBoothConfig = useSelector(state => state.photo_booth_configs)?.find(pbc => pbc.id.toString() === props.photo_booth_id)

  return <PhotoBooth
    locale={"en"}
    tagOwner={tagOwner}
    photoBoothConfig={photoBoothConfig} />
}

const PhotoBoothCellPlugin = {
  Renderer: (props) => {
    const {photo_booth_config_id} = props.data

    return <RenderedPhotoBooth photo_booth_id={photo_booth_config_id}/>
  },

  id: 'photo-booth-cell-plugin',
  title: 'Photo Booth',
  description: 'Photo Booth',
  version: 1,
  allowClickInside: true,
  toolbar_element: document.createElement('div'),
  controls: {
    type: 'custom',
    allowClickInside: true,
    Component: (props) => {
      console.log("Component", props)
      const photoBoothConfigs = useSelector(state => state.photo_booth_configs)
      const options = photoBoothConfigs.map(photoBoothConfig => ({value: photoBoothConfig.id, label: photoBoothConfig.title}))

      return <div className="form-group">
        <label>Photo Booth</label>
        <Select
          defaultValue={options.find(o => o.value === props.data.video_room_id)}
          options={options}
          menuPortalTarget={document.body}
          styles={{menuPortal: base => ({...base, zIndex: 9999})}}
          onChange={val => props.onChange({photo_booth_config_id: val.value})}
        />
      </div>
    },
  },
}

export default PhotoBoothCellPlugin